<template>
  <v-subheader>
    <div
      v-if="label"
      class="field-label"
    >
      {{ label }}
    </div>
    <div class="text">
      {{ itemText }}
    </div>
  </v-subheader>
</template>

<script>

export default {
  name: 'TextField',
  props: {
    field: {
      type: Object,
      required: true
    },
    itemText: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<style scoped>
  .v-subheader {
    padding: 0;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .field-label {
    font-size: 12px;
    line-height: 24px;
  }

  .text {
    font-size: 16px;
  }
</style>
